import { BaseClient } from '../base-client.js';
import RequestResponseHelpers from '../../helpers/RequestResponseHelpers';
import { BASE_URLS } from '../../config';

class DnGroupApiGatewayClient extends BaseClient {
  constructor(config) {
    super(config);
    this.baseUrl = config.baseUrl || BASE_URLS.DN_GROUP_API_GATEWAY[config.env];
  }

  getSegmentsByOneIdAndDomain(oneId, domain) {
    const url = `segments/v1/oneids/${oneId}/domains/${domain}`;
    return this.get({
      url,
      'axios-retry': RequestResponseHelpers.getAxiosRetryConfig(
        3,
        2000,
        RequestResponseHelpers.get5xxStatuses()
      )
    });
  }


  generateRequestConfigForSendingLogToServer(config) {
    const url = `oneid/auth/logging/${config.level}`;
    const client = this.clientName;
    config.data = config.data || {};
    const data = {
      ...config.data,
      client,
      message: config.message
    };
    const newConfig = {
      ...config,
      url,
      data
    };
    return newConfig;
  }

}

export { DnGroupApiGatewayClient };
